

const qiye_id="0";
const qiye_name="0";
const qiye_addr="0";
const qiye_shenfen="0";
const ziyuan_feiyong="0";
const openid="0";
const phone="0";
const name="0";
const locl_url="0";
const denglu_stat=0;
const nichen = "0";
const guanli_page_data = "0";
const hangye = "0";
export default{
    qiye_id,
    qiye_name,
    qiye_addr,
    qiye_shenfen,
    ziyuan_start_timer,
    ziyuan_end_timer,
    ziyuan_feiyong,
    ziyuan_huiyuan,
    openid,
    phone,
    locl_url,
    name,
    denglu_stat,  
    nichen,
    guanli_page_data,
    hangye,
}